/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:37 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Loader = require("ui/loader/Loader");
    var template = require("connection-templates/KPsTab/KPsTabLayout.tmpl");
    var NoData = require("ui.components/no-data/NoData");

    var KPsTabLayout = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        KPsTabLayout = Marionette.Layout.extend({
            className: "kps-tab-container",
            template: template,
            regions: {
                searchInputRegion:".search-input-region",
                searchResultsRegion:".search-results-region",
                whatsNewRegion:".whats_new_region",
                pageRegion:".page_region",
                areaRegion:".area-region",
                recentRegion:".recent-region"
            },
            ui: {
                contextualContent: ".contextual-content",
                kpsContentWrapper: ".kps-content-wrapper",
                searchInputRegion: ".search-input-region",
                recentRegion: ".recent-region"
            },

            initialize: function (options) {
                options = options || {};
                this.mainContainerLayout = options.mainContainerLayout;
            },
            setLoader:function(){
                this._getLoader().render();
            },
            closeLoader: function () {
                this._getLoader().close();
            },
            setNoData:function(){
                this._getNoData().render();
            },
            scrollTop:function(){
                this.ui.kpsContentWrapper.scrollTop(0);
            },
            _getLoader:function(){
                if (!this.loader) {
                    this.loader = new Loader({
                        permutation: Loader.PERMUTATION.L,
                        el: this.ui.contextualContent,
                        zIndex:2
                    });
                }
                return this.loader;
            },
            _getNoData:function(){
                if(!this.noData){
                    this.noData = new NoData({
                        el: this.el,
                        permutation: NoData.PERMUTATION.REFRESH_LINK_MEDIUM,
                        callback: _.bind(this._onNoDataClick, this),
                        errorMessage: LE.translator.translate("LEConnection.connectionPanel.error404")
                    });
                    return this.noData;
                }
            },
            _onNoDataClick:function(){
                LE.navigator.reload();
            },

            setRecentlyPosition: function() {
                this.ui.kpsContentWrapper.scrollTop(this.ui.recentRegion.offset().top - this.ui.kpsContentWrapper.offset().top + this.ui.kpsContentWrapper.scrollTop());
            }
        });
    });
    return KPsTabLayout;
});

